var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"damage-table"},[_c('div',{class:{ 'damage-table-toolbar': 1, transparent: _vm.transparentToolbar }},[_vm._t("toolbar")],2),_c('table',[_c('thead',[_c('tr',[_vm._t("head")],2)]),_c('tbody',[_vm._t("body")],2)]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }